const NavigationMenu = () => null;

export default NavigationMenu;
